// src/pages/Users/Techniques/utils/speechUtils.js

export function hasJapaneseCharacters(
  value = "",
) {
  return /[\u3040-\u30FF\u4E00-\u9FFF]/.test(
    value,
  );
}

export function pickJapaneseVoice() {
  if (
    typeof window === "undefined" ||
    !window.speechSynthesis
  ) {
    return {
      voice: null,
      lang: "ja-JP",
    };
  }

  const voices =
    window.speechSynthesis.getVoices?.() ||
    [];

  const japaneseVoice =
    voices.find((voice) =>
      voice.lang
        ?.toLowerCase()
        .startsWith("ja"),
    ) || null;

  return {
    voice: japaneseVoice,
    lang:
      japaneseVoice?.lang || "ja-JP",
  };
}

export function speakJapanese(text) {
  try {
    if (
      typeof window === "undefined" ||
      !window.speechSynthesis ||
      !text
    ) {
      return false;
    }

    window.speechSynthesis.cancel();

    const { voice, lang } =
      pickJapaneseVoice();

    const utterance =
      new SpeechSynthesisUtterance(
        text,
      );

    if (voice) {
      utterance.voice = voice;
    }

    utterance.lang = lang;
    utterance.rate = 0.86;
    utterance.pitch = 1;
    utterance.volume = 1;

    window.speechSynthesis.speak(
      utterance,
    );

    return true;
  } catch (error) {
    console.error(
      "Erreur de prononciation :",
      error,
    );

    return false;
  }
}